export const btn_value = [
  "All",
  "Governor",
  "Deputy Governor",
  "Senator",
  "House of Representatives",
  "House of Assembly",
  "LGA Chairman",
  "LGA Counsellors",
];

export const data_reps = [
  {
    image: "/assets/images/home/img-1.png",
    badge: 2,
    name: " John Adeyemi",
    party: "All Progressives Congress, (APC)",
    position: "Edo State Governor ",
  },
  {
    image: "/assets/images/home/img-2.png",
    badge: 1,
    name: " John Adeyemi",
    party: "Peoples Democratic Party, (PDP)",
    position: "Deputy Governor",
  },
  {
    image: "/assets/images/home/img-3.png",
    badge: 1,
    name: " John Adeyemi",
    party: "All Progressives Congress, (APC)",
    position: "House of Representatives",
  },

  {
    image: "/assets/images/home/img-5.png",
    badge: 2,
    name: "Abimbola Asiwaju",
    party: "All Progressives Congress, (APC)",
    position: "LGA Chairman ",
  },
  {
    image: "/assets/images/home/img-6.png",
    badge: 2,
    name: "Abimbola Asiwaju",
    party: "All Progressives Congress, (APC)",
    position: "LGA Chairman ",
  },
  {
    image: "/assets/images/home/img-3.png",
    badge: 1,
    name: " John Adeyemi",
    party: "All Progressives Congress, (APC)",
    position: "House of Representatives",
  },

  {
    image: "/assets/images/home/img-5.png",
    badge: 2,
    name: "Abimbola Asiwaju",
    party: "All Progressives Congress, (APC)",
    position: "LGA Chairman ",
  },
  {
    image: "/assets/images/home/img-6.png",
    badge: 2,
    name: "Abimbola Asiwaju",
    party: "All Progressives Congress, (APC)",
    position: "LGA Chairman ",
  },
];

export const data_neewsfeed = [
  {
    profileImg: "/assets/images/newsfeed/profile-01.png",
    name: "Women of Change",
    date: "1 week ago",
    contents: `Youth Voter Turnout Surges in 2024 Elections Registration Drive
  The Independent National Electoral Commission (INEC) has reported a significant increase in youth voter registration ahead of the 2024 general elections. According to INEC, over 5 million new voters between the ages of 18-25 have registered in the last two months, showing a remarkable surge in youth political engagement.
  Youth Vote Initiative spokesperson, Ifeanyi Udeh, praised the turnout: "This is a sign that Nigerian youth are ready to take their place in the decision-making process. We are committed to ensuring that every young Nigerian is educated on how to vote and make their voice count."
  With less than six months to go before the elections, civil society groups are also ramping up efforts to increase voter education and mobilize first-time voters.r`,
    image: [
      "/assets/images/newsfeed/main-1.png",
      "/assets/images/newsfeed/main-11.png",
    ],
    social: {
      message: 300,
      repost: 120,
      like: 220,
    },
  },
  {
    profileImg: "/assets/images/newsfeed/profile-02.png",
    name: "Nigerian Youth Congress",
    date: "1 week ago",
    contents: `Nationwide Peace Campaign Launched to Ensure Violence-Free Elections
  
  A coalition of civil society organizations and youth advocacy groups has launched a nationwide peace campaign to promote violence-free elections ahead of Nigeria's 2024 general elections. The campaign, titled "Vote Peacefully, Nigeria Decides," aims to reduce electoral violence and ensure a safe and transparent voting process.
  The campaign includes town hall meetings, media outreach, and community-based engagements to encourage peaceful participation in the elections. The Youth Vote Initiative is one of the key partners in this project, emphasizing the importance of non-violence, especially among first-time voters.
  "Every election season, we face the challenge of violence at polling stations. This year, we're working hard to make sure all Nigerians can vote safely and peacefully," said Hon. Maryam Sule, one of the campaign's coordinators.
  The initiative has already been praised by several political leaders and electoral bodies for its proactive approach.`,
    image: ["/assets/images/newsfeed/main-2.png"],
    social: {
      message: 203,
      repost: 90,
      like: 50,
    },
  },
  {
    profileImg: "/assets/images/newsfeed/profile-01.png",
    name: "John Adeyemi",
    date: "1 week ago",
    contents: `Dear Citizens,
  I hope this message finds you and your loved ones in good health and high spirits. As your representative, it is my honor and duty to keep you informed, engaged, and empowered. I am writing to share some exciting updates and remind you of our shared goals for a better, stronger community.
  1. Supporting Local Businesses: Our local businesses are the backbone of our economy. We’ve launched new initiatives to provide grants and low-interest loans to help businesses thrive. I encourage everyone to shop local and support our community entrepreneurs.
  2. Improving Public Services: We are making strides in improving public transportation, healthcare facilities, and education. Our new projects aim to reduce commute times, increase access to quality healthcare, and provide better resources for our schools.`,
    image: [
      "/assets/images/newsfeed/main-31.png",
      "/assets/images/newsfeed/main-32.png",
      "/assets/images/newsfeed/main-33.png",
    ],
    social: {
      message: 420,
      repost: 190,
      like: 550,
    },
  },
];

export const more_report_data = [
  {
    title: "Nigeria's Youth Voter Turnout Surges",
    date: "1 week ago",
    image: "/assets/images/home/post-1.png",
    name: "Nigeria's",
    profile: "/assets/icons/messages/image-1.png",
  },
  {
    title: "Nigeria's Youth Voter Turnout Surges",
    date: "1 week ago",
    image: "/assets/images/home/post-3.png",
    name: "Nigeria's",
    profile: "/assets/icons/messages/image-2.png",
  },

  {
    title: "Nigeria's Youth Voter Turnout Surges",
    date: "1 week ago",
    image: "/assets/images/home/post-2.png",
    name: "Nigeria's",
    profile: "/assets/icons/messages/image-3.png",
  },
];
